
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.751 20.749v.679a1.045 1.045 0 01-1 1.073H4.522a1.06 1.06 0 01-1.021-1.092V5.824A1.046 1.046 0 014.506 4.75H5v-1.5h-.52a2.55 2.55 0 00-2.479 2.592v15.553a2.56 2.56 0 002.489 2.608h12.281a2.555 2.555 0 002.479-2.6v-.655z"}}),_c('path',{attrs:{"d":"M7.489 20.75A2.56 2.56 0 015 18.142V2.595A2.55 2.55 0 017.479.003H16.4a2.473 2.473 0 011.784.775l3.346 3.521a2.625 2.625 0 01.719 1.819v12.039a2.555 2.555 0 01-2.479 2.6H7.489zM7.505 1.5A1.046 1.046 0 006.5 2.574v15.585a1.06 1.06 0 001.021 1.092H19.75a1.045 1.045 0 001-1.073V6.113a1.138 1.138 0 00-.309-.786l-3.346-3.521a.974.974 0 00-.7-.306z"}}),_c('path',{attrs:{"d":"M8.918 10.48a.749.749 0 01.749-.749h4.5a.75.75 0 010 1.5h-4.5a.751.751 0 01-.751-.749zM17.915 13.479a.749.749 0 01-.749.75h-7.5a.75.75 0 010-1.5h7.5a.749.749 0 01.749.749zM17.894 16.478a.75.75 0 01-.75.75H9.669a.75.75 0 010-1.5h7.474a.749.749 0 01.751.748z"}})])
          )
        }
      }
    